import { useConcatenateFilterSelection } from '../../components/filters/hooks/common.hook';
import { useFilterDrilltroughSelection } from '../../components/filters/hooks/use-filter-drillthrough-selection.hook';
import { useFilterPanelSelection } from '../../components/filters/hooks/use-filter-panel-selection.hook';
import { AppForceSelectionModal } from '../demand/components/app-force-selection.modal';
import { useAppForceSelection } from '../demand/components/hooks/use-app-force-selection.hook';
import DecompComponent from './decomp.component';

export const DecompPageComponent = () => {
  const { enabled, handleForceSelClose, showPopup } = useAppForceSelection();
  const filterSelection = useFilterPanelSelection();

  const filterSelectionDrillthrough = useFilterDrilltroughSelection();

  const filterSelectionDecompModel = useConcatenateFilterSelection(
    filterSelection,
    filterSelectionDrillthrough,
  );
  return (
    <>
      <DecompComponent
        reportName="decomp"
        filterSelection={filterSelectionDecompModel}
        enabled={enabled}
      />
      <AppForceSelectionModal
        filterSelection={filterSelection}
        onClose={handleForceSelClose}
        show={showPopup}
        enabled={enabled}
        title="Select Market"
      />
    </>
  );
};
export default DecompPageComponent;
